import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["allTab", "activeTab", "deactivatedTab", "objective"]

  connect() {
    // Set initial active tab (All)
    this.setActiveTab(this.allTabTarget)
  }

  filterAll(event) {
    event.preventDefault()
    this.setActiveTab(this.allTabTarget)
    this.showObjectives("")
  }

  filterActive(event) {
    event.preventDefault()
    this.setActiveTab(this.activeTabTarget)
    this.showObjectives("active")
  }

  filterDeactivated(event) {
    event.preventDefault()
    this.setActiveTab(this.deactivatedTabTarget)
    this.showObjectives("deactivated")
  }

  setActiveTab(activeTab) {
    // Remove active classes from all tabs
    [this.allTabTarget, this.activeTabTarget, this.deactivatedTabTarget].forEach(tab => {
      tab.classList.remove("border-blue-500", "text-blue-600")
      tab.classList.add("border-transparent", "text-gray-500")
    })

    // Add active classes to clicked tab
    activeTab.classList.remove("border-transparent", "text-gray-500")
    activeTab.classList.add("border-blue-500", "text-blue-600")
  }

  showObjectives(statusFilter) {
    // Show/hide objectives based on filter
    this.objectiveTargets.forEach(objective => {
      const objectiveState = objective.dataset.state

      if (statusFilter === "" || objectiveState === statusFilter) {
        objective.classList.remove("hidden")
      } else {
        objective.classList.add("hidden")
      }
    })

    // Check if any objectives are visible
    const visibleObjectives = this.objectiveTargets.filter(objective => !objective.classList.contains("hidden"))
    const emptyState = this.element.querySelector("[data-empty-state]")

    if (visibleObjectives.length === 0 && emptyState) {
      emptyState.classList.remove("hidden")
    } else if (emptyState) {
      emptyState.classList.add("hidden")
    }
  }
}
